import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import * as CheckUserModule from "@/redux/modules/api/data/checkUser/checkUser.module";
import * as CheckUserSelectors from "@/redux/modules/api/data/checkUser/checkUser.selectors";
import * as CustomerModule from "@/redux/modules/api/data/customer/customer.module";
import * as CustomerSelectors from "@/redux/modules/api/data/customer/customer.selectors";
import * as OrderDetailsSelectors from "@/redux/modules/api/data/orderDetail/orderDetail.selectors";

import ConfirmGuest from "./confirmGuest.component";

type Props = {
    innerHTML: string;
    link: string;
};

const ConfirmGuestContainer = ({ innerHTML, link }: Props) => {
    const dispatch = useThunkDispatch();
    const order = useSelector(OrderDetailsSelectors.getOrder);
    const userExist = useSelector(CheckUserSelectors.doesUserExist);
    const isLoading = useSelector(CustomerSelectors.isLoading);

    const [userCreatedState, setUserCreatedState] = useState(false);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (order) {
            dispatch(CheckUserModule.load(order.customer.email));
        }
    }, [order?.orderId]);

    const submitHandler = (password: string) => {
        if (!order) {
            return;
        }
        return dispatch(
            CustomerModule.confirmGuest(order.orderId, password)
        ).then((action) => {
            if (action.type === CustomerModule.APIStatus.SUCCESS) {
                setUserCreatedState(true);
            }
        });
    };

    return (
        <>
            {order?.customer.guest && !userExist && (
                <ConfirmGuest
                    email={order.customer.email}
                    submit={submitHandler}
                    link={link}
                    userCreated={userCreatedState}
                    isLoading={isLoading}
                >
                    <div dangerouslySetInnerHTML={{ __html: innerHTML }} />
                </ConfirmGuest>
            )}
        </>
    );
};

export { ConfirmGuestContainer };
